import Token from "../models/token";

const TokenServices = (function () {
  // Set Token, Refresh_token and Expiration Time  into localStorage
  function _setToken(token: Token) {
    localStorage.setItem("ACCESS_TOKEN", token.getToken());
    localStorage.setItem("REFRESH_TOKEN", token.getRefreshToken());
    localStorage.setItem(
      "TOKEN_EXPIRATION_TIME",
      token.getExpirationTime().toString()
    );
  }

  function _getAccessToken() {
    return localStorage.getItem("ACCESS_TOKEN");
  }

  function _getRefreshToken() {
    return localStorage.getItem("REFRESH_TOKEN");
  }

  function _getExpirationTime() {
    return Number(localStorage.getItem("TOKEN_EXPIRATION_TIME"));
  }

  function _clearToken() {
    localStorage.removeItem("ACCESS_TOKEN");
    localStorage.removeItem("REFRESH_TOKEN");
    localStorage.removeItem("TOKEN_EXPIRATION_TIME");
  }

  function _isActive() {
    const expires = _getExpirationTime();
    const now = new Date().getTime();
    let response = false;
    if (!!expires) {
      if (expires > now) response = true
    }
    return response;
  }

  return {
    setToken: _setToken,
    getAccessToken: _getAccessToken,
    getRefreshToken: _getRefreshToken,
    clearToken: _clearToken,
    getExpirationTime: _getExpirationTime,
    expirationTime: _getExpirationTime,
    isActive: _isActive,
  };
})();

export default TokenServices;
